export const ModulesMessages = {
    HOME_MODULE: 'Home',
    ASSISTANT_MODULE: 'Asistentes',
    TENDERS: 'Licitaciones',
    ADMIN: 'Administración',
};
